import { render, staticRenderFns } from "./handhome3.vue?vue&type=template&id=0ed085c8&scoped=true"
import script from "./handhome3.vue?vue&type=script&lang=js"
export * from "./handhome3.vue?vue&type=script&lang=js"
import style0 from "./handhome3.vue?vue&type=style&index=0&id=0ed085c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed085c8",
  null
  
)

export default component.exports